import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/stevensReport'
import Component from 'components/Reports/StevensReport'

export default createListViewContainer({ actions, selectors: selectors.stevensReport })(Component)
